import { render, staticRenderFns } from "./EditTenantModal.vue?vue&type=template&id=c9bfe31e&"
import script from "./EditTenantModal.vue?vue&type=script&lang=js&"
export * from "./EditTenantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports